import React from 'react';
import styles from './About.module.css';
import AboutImage from '../../assets/images/img.svg'; // <- Imagem ao lado do texto

const About = () => {
  return (
    <section className={styles.about}>
      <div className={styles.AbountContainer}>
        <div className={styles.imageContainer}>
          <img src={AboutImage} alt="Sobre a Traily" />
        </div>
        <p>
          Somos a <strong>Traily</strong>, uma empresa que oferece soluções em recompensas e benefícios com foco em experiências de verdade — como vouchers de cinema, games e outros conteúdos digitais. Atuamos de forma simples, flexível e eficiente para campanhas promocionais, programas de incentivo e ações corporativas.
        </p>
      </div>
    </section>
  );
};

export default About;
